import React from 'react';
import cx from 'classnames';

import { StaticComponent } from '../../../../../../utilities/hooks/hocs';
import VehicleCardPlaceholderBox from '../../../../../shared/VehicleCards/VehicleCardPlaceholderBox/VehicleCardPlaceholderBox';
import AccountVehicleCardImage from '../AccountVehicleCardImage/AccountVehicleCardImage';

import styles from './AccountVehicleCardLoadingView.module.scss';

const AccountVehicleCardLoadingView = StaticComponent(() => (
	<div className={styles.accountVehicleCardLoadingView}>
		<header>
			<div className={styles.photoArea}>
				<AccountVehicleCardImage placeholder />
			</div>
			<div className={styles.vrm}>
				<VehicleCardPlaceholderBox className={cx(styles.placeholder, styles.placeholderVRM)} />
				<div className={styles.name}>
					<VehicleCardPlaceholderBox className={cx(styles.placeholder, styles.placeholderName)} />
					<VehicleCardPlaceholderBox className={cx(styles.placeholder, styles.placeholderName)} />
				</div>
			</div>
		</header>
		<div className={styles.bidArea}>
			<VehicleCardPlaceholderBox className={cx(styles.placeholder, styles.placeholderBid)} />
		</div>
		<div className={styles.tags}>
			<VehicleCardPlaceholderBox className={cx(styles.placeholder, styles.tag)} />
			<VehicleCardPlaceholderBox className={cx(styles.placeholder, styles.tag)} />
		</div>
	</div>
));

AccountVehicleCardLoadingView.displayName = 'AccountVehicleCardLoadingView';

export default AccountVehicleCardLoadingView;
